const monthKey = date => (date || '').slice(0, 7)

export const slotDate = month => `${month}-01`

export const DAY_START_MINUTES = 4 * 60

const toMinutes = time => {
  const parts = (time || '').split(':')
  return (Number(parts[0]) || 0) * 60 + (Number(parts[1]) || 0)
}

export const minutesFromDawn = time => (toMinutes(time) - DAY_START_MINUTES + 1440) % 1440

export const byMonthAndTime = (a, b) =>
  a.month === b.month ? minutesFromDawn(a.time) - minutesFromDawn(b.time) : a.month.localeCompare(b.month)

export const getSlots = frames => {
  const map = {}

  frames.forEach((frame, index) => {
    ;(frame.sunlightConditions || []).forEach(condition => {
      const month = monthKey(condition.date)
      if (!month || !condition.time) return

      const key = `${month}|${condition.time}`
      if (!map[key]) map[key] = { month, time: condition.time, images: {} }
      map[key].images[index] = condition
    })
  })

  return Object.values(map).sort(byMonthAndTime)
}

export const framesToSlots = frames =>
  JSON.parse(
    JSON.stringify(
      getSlots(frames).map(slot => ({
        time: slot.time,
        month: slot.month,
        isDefault: Object.values(slot.images).some(condition => condition.isDefault),
        images: frames.map((frame, index) => (slot.images[index] && slot.images[index].image) || null),
      })),
    ),
  )

const seriesNumber = file => {
  const match = file.name.match(/(\d+)(?=\.[^.]+$)/)
  return match ? parseInt(match[1], 10) : Number.MAX_SAFE_INTEGER
}

export const seriesOrder = files => [...files].sort((a, b) => seriesNumber(a) - seriesNumber(b))
